import React from 'react';

const BannerComponent = () => {

return (


  <div className="carousel slide container" data-ride="carousel" id="slider">
                <div className="carousel-inner">

                    <div className="carousel-item active">
                       <a href="https://fatinabila.github.io/covid19-dashboard/" target="_blank" rel="noopener noreferrer"> 
                         <img src="img/bannerIntro4.png" className="d-block w-100" alt="..."/>
                       </a>
                    </div>

               
                </div>

            </div>
        


)}
export default BannerComponent;